export class AirlineMasterProperties {
  airlineID: number = 0;
  airlineLogoName: string = "";
  airlineNumCode: string = "";
  airlinePrefixCode: string = "";
  airlineCombineCode: string = "";
  airlineLegalName: string = "";
  airlineLogo: string = "";
  airlineStatus: string = "";
  datetime: string = "";
  userId: number = 0;

}
